define('boxes/events/paymentEvent',[], function() {
    'use strict';

    var PaymentEvent = {};
    PaymentEvent.PAYMENT_SETUP_DONE = 'PAYMENT_SETUP_DONE';
    PaymentEvent.PENDING = 'PENDING';
    PaymentEvent.SHOW_FAIL_MESSAGE = 'SHOW_FAIL_MESSAGE';
    PaymentEvent.UPDATE_AMOUNT = 'UPDATE_AMOUNT';
    PaymentEvent.TOTAL_BALANCE_AFTER_TRANSACTION = 'TOTAL_BALANCE_AFTER_TRANSACTION';
    PaymentEvent.AMOUNT_IN_TRANSACTION = 'AMOUNT_IN_TRANSACTION';
    PaymentEvent.PIXEL_TRACKING = 'PIXEL_TRACKING';
    PaymentEvent.REMOVE_LOADING = 'REMOVE_LOADING';
    PaymentEvent.IS_INSTANT_DEPOSIT = 'IS_INSTANT_DEPOSIT';
    PaymentEvent.IS_NORMAL_DEPOSIT = 'IS_NORMAL_DEPOSIT';
    PaymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED = 'SUCCESSFUL_TRANSACTION_COMPLETED'
	PaymentEvent.TRANSACTION_FAILED = 'TRANSACTION_FAILED';
    return PaymentEvent;
});

